import { ENV } from "../Utils"; // Asegúrate de que la ruta a Utils es correcta

export class UsersDB {
  baseApi = ENV.BASE_API;

  async getListsimpleData(id_Client) {
    const url = `${this.baseApi}/usersdb/details/${id_Client}`;
    try {
      const response = await fetch(url);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(`Failed to fetch users: ${result.message}`);
      }
      //console.log('result', result);
      return result;
    } catch (error) {
      console.error("Failed to fetch users:", error);
      throw error;
    }
  }

  async getAllUsersByClient(id_Client) {
    const url = `${this.baseApi}/usersdb/${id_Client}`;
    try {
      const response = await fetch(url);
      const result = await response.json();
      //console.log('result', result);
      if (response.status !== 200) {
        throw new Error(`Failed to fetch users: ${result.message}`);
      }
      return result;
    } catch (error) {
      console.error("Failed to fetch users:", error);
      throw error;
    }
  }

  // Método para eliminar un usuario
  async deleteUserOfClient(id, userId) {
    const url = `${this.baseApi}/clientdbUser/${id}/${userId}`;

    try {
      const response = await fetch(url, {
        method: "DELETE", // Especificamos el método DELETE
        headers: {
          "Content-Type": "application/json", // Si necesitas mandar algún tipo de autenticación, inclúyela aquí
        },
      });

      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(`Failed to delete user: ${result.message}`);
      }

      return result;
    } catch (error) {
      console.error("Failed to delete user:", error);
      throw error;
    }
  }
}
